import React from "react";

const PHONE = "420732434878"; // mezinárodní formát bez "+" pro wa.me
const PRESET = encodeURIComponent(
  "Dobrý den, mám zájem o voucher CarSpa s bonusem +50 %. Můžete mi prosím poslat detaily?"
);

export const WhatsAppFab = () => {
  return (
    <a
      href={`https://wa.me/${PHONE}?text=${PRESET}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Napsat nám na WhatsApp"
      className="fixed bottom-5 left-5 sm:bottom-6 sm:left-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" aria-hidden />
      <span className="relative flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1FB856] text-white pl-3 pr-3 sm:pr-5 py-3 rounded-full shadow-[0_10px_30px_-5px_rgba(37,211,102,0.5)] transition-colors">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="currentColor"
          aria-hidden
        >
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" />
        </svg>
        <span className="hidden sm:inline text-[11px] tracking-[0.2em] uppercase font-semibold whitespace-nowrap">
          WhatsApp
        </span>
      </span>
    </a>
  );
};

export default WhatsAppFab;
